import Styles from './Callout.module.scss';

const Callout = ({ children, content }) => {
  return <div className={Styles.container}>{content || children}</div>;
};

export default Callout;
